import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { ContainerProps } from 'react-bootstrap';
import { twMerge } from '@/lib/twMerge';

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, fluid = false, className = '', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          clsx(
            'tw-px-4',
            fluid && 'tw-w-full',
            !fluid && 'tw-container tw-mx-auto tw-max-w-7xl'
          ),
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
